/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Rtl_LayoutsInputs */

const en_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL layouts`)
};

const ar_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخطيطات RTL`)
};

const bn_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL লেআউট`)
};

const de_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL-Layouts`)
};

const es_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseños RTL`)
};

const fr_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mises en page RTL`)
};

const pt_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layouts RTL`)
};

const zh_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL 版式`)
};

const tr_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL düzenler`)
};

const ru_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RTL-раскладки`)
};

const pl_svchip_rtl_layouts = /** @type {(inputs: Svchip_Rtl_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Układy RTL`)
};

/**
* | output |
* | --- |
* | "RTL layouts" |
*
* @param {Svchip_Rtl_LayoutsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_rtl_layouts = /** @type {((inputs?: Svchip_Rtl_LayoutsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Rtl_LayoutsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_rtl_layouts(inputs)
	if (locale === "bn") return bn_svchip_rtl_layouts(inputs)
	if (locale === "de") return de_svchip_rtl_layouts(inputs)
	if (locale === "es") return es_svchip_rtl_layouts(inputs)
	if (locale === "fr") return fr_svchip_rtl_layouts(inputs)
	if (locale === "pt") return pt_svchip_rtl_layouts(inputs)
	if (locale === "zh") return zh_svchip_rtl_layouts(inputs)
	if (locale === "tr") return tr_svchip_rtl_layouts(inputs)
	if (locale === "ru") return ru_svchip_rtl_layouts(inputs)
	if (locale === "pl") return pl_svchip_rtl_layouts(inputs)
	return en_svchip_rtl_layouts(inputs)
});